<template>
  <div>
    <div style="display:flex;">
      <div style="flex:1">服务商: {{row.name}}</div>
      <div style="flex:1">可服务类型: {{getModuleTypes(row.moduleTypes)}}</div>
    </div>
    <div style="padding:1rem 0;">服务信息</div>
    <div style="padding-bottom:1rem;">
          <el-button
            size="mini"
            type="primary"
            @click="handleAdd()">添加</el-button>
    </div>
    <el-form ref="formRef" :model="form">
        <el-table :data="form.list" border>
          <el-table-column label="服务项目名称" width="250px">
            <template slot-scope="scope">
              <!-- 为了区分是哪一行进行的校验，需要动态绑定 prop 到 el-form-item 元素-->
              <!-- prop/rules/v-model三者的值必须一致，校验才能生效 -->
              <el-form-item
                :prop="'list.' + scope.$index + '.serviceItemId'"
                :rules="rules.serviceItemId"
              >
                <!-- <el-input
                  v-model="scope.row.serviceItemId"
                  placeholder="请输入姓名"
                ></el-input> -->
                <el-select
                 :disabled="model==='view'" 
                v-model="scope.row.serviceItemId"
                style="width: 100%"
                placeholder="请选择 服务项目名称"
                @change="serviceItemIdChange(scope.row.serviceItemId,scope.$index)"
              >
                <el-option
                  v-for="item in providerServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"

                >
                </el-option>
              </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="服务小区/网点" width="250px">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.communityIdsList'"
                :rules="rules.communityIdsList"
              >
                <el-select
                multiple
                 :disabled="model==='view'" 
                v-model="scope.row.communityIdsList"
                style="width: 100%"
                placeholder="请选择 服务小区/网点"
                @change="communityIdChange"
              >
                <el-option
                  v-for="item in communityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"

                >
                </el-option>
              </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="预付费（元）" width="250px">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.dropInFee'"
              >
              <money-input v-model="scope.row.dropInFee" 
                :disabled="true"
               placeholder="请输入 标准费用（元）" template="append" style="width: 100%"  />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="标准费用（元）" width="250px">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.standardFee'"
                :rules="rules.standardFee"
              >
              <money-input :ref="'standardFee'+scope.$index" v-model="scope.row.standardFee" @blur="standardFeeBlur(scope.$index, scope.row.standardFee, scope)" placeholder="请输入 标准费用（元）" template="append" style="width: 100%;"/>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="备注" width="250px">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.description'"
                :rules="rules.description"
              >
                <el-input
                  v-model="scope.row.description"
                  placeholder="请输入 备注"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250px">
            
            <template slot-scope="scope">
      <el-button type="danger" @click="handleDel(scope.$index)" size="small"> 删除 </el-button>
            </template>
          </el-table-column>
        </el-table>
    <div style="text-align: right" v-if="model != 'view'">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveServiceForm" size="small">
        {{ model == 'add' ? '提交' : '提交' }}
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
      </el-form>
  </div>
</template>
<script>
import {
  submitServiceInfo,getProviderServiceList,getCommunityList,
  getProviderServiceItemList
} from '../api/serveItemManage';
import { getDictionary } from '@/api/common.js';
export default {

  props: {
    row: {
      default: {},
    },
    providerId: {},
    projectId:{},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      communityList:[],
      providerServiceList:[],
          form: {
            // 表格数据 list 为 表单数据 form 的嵌套元素
            list: [
              { serviceItemId: "", communityIdsList: [], standardFee: "", communityIds:'',description:'',dropInFee:'' },
            ],
          },



rules: {
            serviceItemId: [
              { required: true, message: "请选择服务项目名称", trigger: "blur" },
            ],
            communityIdsList: [
              { required: true, message: "请选择小区", trigger: "blur" },
              // {
              //   validator: function (rule, value, callback) {
              //     if (/^[0-9]*$/.test(value) == false) {
              //       callback(new Error("请输入正确的数字"));
              //     } else {
              //       callback();
              //     }
              //   },
              //   trigger: "blur",
              // },
            ],
            standardFee: [
              { required: true, message: "请输入标准费用", trigger: "blur" },
              // {
              //   validator: function (rule, value, callback) {
              //     console.log("validator==========>",rule,this);
              //     if (/^[0-9]*$/.test(value) == false) {
              //       callback(new Error("格式错误"));
              //     } else {
              //       callback();
              //     }
              //   },
              //   trigger: "blur",
              // },
              // { type: "email", message: "请输入正确的Email", trigger: "blur" },
            ],
          },
          moduleTypeList:[],
          standardFeeValidFlag:false,

    }
  },
  created() {
    this.initData();
  },
  methods:{
    serviceItemIdChange(val,i){
      console.log('serviceItemIdChange=============',val,i);
      this.providerServiceList.forEach(ele=>{
        if(ele.id===val){
          this.form.list[i].dropInFee = ele.dropInFee;
        }
      })
      this.form = this._.cloneDeep(this.form);
    },
    standardFeeBlur(index,standardFee,scope){
      console.log(index,standardFee,scope);
      this.standardFeeValidFlag = false;
      this.$refs['standardFee'+index].$el.style.border = '';
      if(Number(scope.row.dropInFee)+''!=='NaN'){
        if(Number(scope.row.dropInFee)>Number(scope.row.standardFee)){
          this.$message({
            type: 'error',
            message: '标准费用不能小于预付费'
          })
          this.standardFeeValidFlag = true;
          this.$refs['standardFee'+index].$el.style.border = '1px solid red';
          console.log("standardFeeBlur=============>",this.$refs['standardFee'+index]);
        }
      }
    },
    communityIdChange(){
      this.form = this._.cloneDeep(this.form);
    },
    getModuleTypes(ids){
      let arrIds = ids.split(',');
      let arrNames = [];
      this.moduleTypeList.forEach(ele=>{
        arrIds.forEach(elem=>{
          if(ele.dictKey===elem){
            arrNames.push(ele.dictValue);
          }
        })
      })
      return arrNames.join(',');

    },
    initData(){
      getProviderServiceItemList({providerId:this.row.id}).then((res)=>{
        this.form.list = res.data;
        this.form.list.forEach(ele=>{
          ele.communityIdsList = ele.communityIds.split(',');
        });
      });
      getProviderServiceList({providerId:this.row.id}).then((res)=>{
        this.providerServiceList = res.data;
        let self = this;
        this.form.list.forEach((ele,i)=>{
          self.serviceItemIdChange(ele.serviceItemId,i);
        })
      })
      getCommunityList({projectId:this.row.projectId}).then(res=>{
        this.communityList = res.data;
      });
      getDictionary('out_order_module_type').then((res) => {
        this.moduleTypeList = res.data;
      });
    },
    handleAdd(){
      this.form.list.push({
        serviceItemId:'',
        communityIdsList:'',
        standardFee:'', communityIds:'',description:''
      });
    },
    handleDel(index){
      console.log(index,"====");
      this.form.list.splice(index, 1);
      // this.form.list.push({
      //   serviceItemId:'',
      //   communityIdsList:'',
      //   standardFee:'', communityIds:'',description:''
      // });
    },
    saveServiceForm(){
        this.$refs['formRef'].validate((valid) => {
          if (valid) {
            
            this.form.list.forEach(ele=>{
              ele.communityIds = ele.communityIdsList.join(',');
            })
            this.form.providerItemList = this.form.list;
            this.form.id = this.row.id;
            console.log("this.form===============>",this.form);
            if(this.standardFeeValidFlag){
              return;
            }
            submitServiceInfo(this.form).then((res) => {
              this.$message.success('配置成功');
              this.$emit('success');
            });
          }
        });
    },
    
    
    cancleRecord() {
      this.$emit('cancle');
    },

  }
}
</script>
